import BaseProxy from './Proxy';

export default class AuthProxy extends BaseProxy {
  constructor(parameters = {}) {
    super('api/auth', parameters);
  }

  loginOpenId(params) {
    return this.submit('post', `${this.endpoint}/login/openid`, params);
  }

  login(params) {
    return this.submit('post', `${this.endpoint}/login`, params);
  }

  init() {
    return this.submit('get', `${this.endpoint}/init`);
  }

  captchaReload() {
    return this.submit('get', `${this.endpoint}/captcha/reload`);
  }

  identify(params) {
    return this.submit('post', `${this.endpoint}/identify`, params);
  }

  otpResend() {
    return this.submit('get', `${this.endpoint}/otp/resend`);
  }

  otpVerify(params) {
    return this.submit('post', `${this.endpoint}/otp/verify`, params);
  }
}
